// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as User_Context$DvmAdminFrontendFr from "../../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../common/App_Typography.bs.js";
import * as Flash_Edit_Api$DvmAdminFrontendFr from "./Flash_Edit_Api.bs.js";
import * as Flash_Edit_Page$DvmAdminFrontendFr from "./Flash_Edit_Page.bs.js";
import * as Messages_Flash_Edit$DvmAdminFrontendFr from "../../../intl/messages/flash/Messages_Flash_Edit.bs.js";

function Flash_Edit_Page_Load(Props) {
  var flashIdOpt = Props.flashId;
  var flashTypeOpt = Props.flashType;
  var flashId = flashIdOpt !== undefined ? Caml_option.valFromOption(flashIdOpt) : undefined;
  var flashType = flashTypeOpt !== undefined ? Caml_option.valFromOption(flashTypeOpt) : undefined;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setFetchedFlash = match$2[1];
  var fetchedFlash = match$2[0];
  var fetchFlash = function (flashId, flashType) {
    Flash_Edit_Api$DvmAdminFrontendFr.fetchFlash(userManager, setFetchedFlash, selectedRole, flashType, flashId);
  };
  React.useEffect((function () {
          if (flashId !== undefined && flashType !== undefined) {
            fetchFlash(flashId, flashType);
          }
          
        }), []);
  var tmp;
  var exit = 0;
  if (typeof fetchedFlash === "number") {
    exit = fetchedFlash === /* NotStarted */0 && flashId === undefined ? 2 : 1;
  } else if (fetchedFlash.TAG === /* Ok */0 || flashId === undefined) {
    exit = 2;
  } else {
    tmp = React.createElement(App_Typography$DvmAdminFrontendFr.make, {
          color: "secondary",
          children: intl.formatMessage(Messages_Flash_Edit$DvmAdminFrontendFr.notFound),
          variant: "h3"
        });
  }
  switch (exit) {
    case 1 :
        tmp = React.createElement(Core.Grid, {
              children: React.createElement(Core.CircularProgress, {
                    size: 100
                  }),
              container: true,
              justifyContent: "center"
            });
        break;
    case 2 :
        tmp = React.createElement(Flash_Edit_Page$DvmAdminFrontendFr.make, {
              flashId: flashId,
              flashType: flashType,
              fetchedFlash: fetchedFlash,
              fetchFlash: fetchFlash
            });
        break;
    
  }
  return React.createElement(React.Fragment, undefined, tmp);
}

var Api;

var make = Flash_Edit_Page_Load;

export {
  Api ,
  make ,
}
/* react Not a pure module */
